export default "__VITE_ASSET__0_qSA3Y___"